// extracted by mini-css-extract-plugin
export default {"colonne":"AccordeonLogoImage_colonne__dKgzg"};